__turbopack_context__.v({
  "bar": "FollowNotificationBar-module-scss-module__vyR02G__bar",
  "closeButton": "FollowNotificationBar-module-scss-module__vyR02G__closeButton",
  "error": "FollowNotificationBar-module-scss-module__vyR02G__error",
  "icon": "FollowNotificationBar-module-scss-module__vyR02G__icon",
  "message": "FollowNotificationBar-module-scss-module__vyR02G__message",
  "slideDown": "FollowNotificationBar-module-scss-module__vyR02G__slideDown",
  "success": "FollowNotificationBar-module-scss-module__vyR02G__success",
});
